import { AuxiliumComponent } from "../auxilium-component";

export class InfoGroup extends AuxiliumComponent {
	constructor() {
		super();

		this.heading = this.getAttribute("heading") ?? "";
		this.editID = this.getAttribute("edit-id") ?? "";
		this.editable = this.hasAttribute("editable");

		this.classList.add("information-group");
	}

	parsedCallback() {
		const actionBar = this.querySelector(":scope > chip-actionbar");

		if (this.heading || this.editID || actionBar || this.editable) {
			const headerDiv = document.createElementWithContents("div", this.heading, { className: "information-header" });

			if (this.editID || this.editable) {
				const editButton = document.createElementWithContents("chip-button", null, {
					buttonStyle: "icon",
					icon: "fas fa-pencil",
					className: "information__edit",
					variation: "body",
					size: "sm",
					tooltip: "Edit details",
					onclick: () => this.raiseEvent("editclicked")
				});

				if (this.editID) { editButton.id = this.editID; }

				headerDiv.appendChild(editButton);
			}

			if (actionBar) {
				headerDiv.appendChild(actionBar);
			}

			this.prepend(headerDiv);
		}
	}
}